module.exports = __webpack_public_path__ + "img/AWD_logo_RGB.3f3c3732.png";